import { JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import { ENTERPRISE } from '../constants/routing/Tabs';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { usePurchaseableProductsForTerm } from './useBulkPurchaseOptions';
import { usePageParams } from './usePageParams';
const STARTER_PRODUCT_API_NAME = 'marketing-hub-starter';

// Pages where the banner should be displayed
const INCLUDED_PAGES = [SCREENS.SUITE, SCREENS.MARKETING, SCREENS.SALES, SCREENS.SERVICE, SCREENS.DATA, SCREENS.CMS, SCREENS.CONTENT, SCREENS.FREE];
export const useStarterPromo2025 = ({
  screen
}) => {
  var _annualPurchaseOption, _monthlyPurchaseOptio;
  const {
    tab
  } = usePageParams();

  // Get the purchase options
  const {
    purchaseOptionsForTerm: annualPurchaseOption,
    loading: annualPriceLoading,
    error: annualPriceError
  } = usePurchaseableProductsForTerm({
    apiName: STARTER_PRODUCT_API_NAME,
    queryParamTerm: ANNUAL
  });
  const {
    purchaseOptionsForTerm: monthlyPurchaseOption,
    loading: monthlyPriceLoading,
    error: monthlyPriceError
  } = usePurchaseableProductsForTerm({
    apiName: STARTER_PRODUCT_API_NAME,
    queryParamTerm: MONTHLY
  });
  const annualPrice = annualPurchaseOption === null || annualPurchaseOption === void 0 ? void 0 : annualPurchaseOption.monthly.calculatedPrice;
  const monthlyPrice = monthlyPurchaseOption === null || monthlyPurchaseOption === void 0 ? void 0 : monthlyPurchaseOption.monthly.calculatedPrice;
  const eligibleForPromotion = (annualPurchaseOption === null || annualPurchaseOption === void 0 || (_annualPurchaseOption = annualPurchaseOption.discounts) === null || _annualPurchaseOption === void 0 ? void 0 : _annualPurchaseOption.some(discount => JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.includes(discount.promotionId))) || (monthlyPurchaseOption === null || monthlyPurchaseOption === void 0 || (_monthlyPurchaseOptio = monthlyPurchaseOption.discounts) === null || _monthlyPurchaseOptio === void 0 ? void 0 : _monthlyPurchaseOptio.some(discount => JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.includes(discount.promotionId)));

  // Check if banner should be displayed on current page
  const isValidScreenForPromo = INCLUDED_PAGES.includes(screen) && tab !== ENTERPRISE;
  const loading = annualPriceLoading || monthlyPriceLoading;
  const error = annualPriceError || monthlyPriceError;
  const shouldShowBanner = !loading && !error && eligibleForPromotion && annualPrice && monthlyPrice && isValidScreenForPromo;
  return {
    shouldShowBanner,
    error,
    annualPrice,
    monthlyPrice
  };
};